<ng-container *ngIf="(hasError$ | async) === false">
  <div
    *ngIf="{
      hasPendingChanges: hasPendingChanges$ | async,
      initialLoading: initialLoading$ | async,
      skipConfigurator: skipConfigurator$ | async,
    } as data">
    <div
      class="cx-update-msg"
      [class.visible]="data.hasPendingChanges || data.initialLoading || data.skipConfigurator"
      [class.pending-changes]="data.hasPendingChanges">
      <div class="row" [ngClass]="{'vh-100 align-items-center': data.initialLoading || data.skipConfigurator}">
        <div class="col text-center">
          <div class="loading-indicator">
            <dcp-loading-indicator></dcp-loading-indicator>
          </div>
          <p class="m-4" *ngIf="data.hasPendingChanges && data.initialLoading === false">
            {{ 'configurator.header.updateMessage' | cxTranslate }}
          </p>
          <p class="m-4" *ngIf="data.initialLoading || data.skipConfigurator">
            {{ 'configurator.header.initialUpdateMessage' | cxTranslate }}
          </p>
        </div>
      </div>
    </div>
  </div>
</ng-container>
